"use client";
import { BugsnagErrorBoundary } from "@/shared/lib/bugsnagClient";

export default function ClientBugsnagWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>;
}
